import React, { VFC, ReactElement } from 'react';
import { CheckmarkStrongIcon } from 'src/monet/icons';
import { Nullable } from 'src/types/nullable.type';

interface DashboardSettingsBillingSubscriptionCardProps {
  title: string;
  subTitle: string;
  features: string[];
  contentContainerClassName?: string;
  renderContent?: () => Nullable<ReactElement>;
  renderFooter?: () => Nullable<ReactElement>;
}

export const DashboardSettingsBillingSubscriptionCard: VFC<DashboardSettingsBillingSubscriptionCardProps> = ({
  title,
  subTitle,
  features,
  contentContainerClassName = 'my-6',
  renderContent = () => null,
  renderFooter,
}) => (
  <div className='flex flex-col p-6 w-[420px] border-[1px] rounded-lg border-bedrock-gray-medium'>
    <div className='flex flex-col antialiased text-bedrock-black mb-4'>
      <h2 className='text-bedrock-serif-h2'>{title}</h2>
      <p className='text-bedrock-p'>{subTitle}</p>
      <div className={contentContainerClassName}>{renderContent()}</div>
      <span className='text-bedrock-p-strong'>What's included?</span>
      <ul className='mt-2 space-y-2'>
        {features.map((feature, idx) => (
          <li key={`feature-${idx}`} className='flex space-x-4 items-center'>
            <CheckmarkStrongIcon className='shrink-0' />
            <span className='text-bedrock-p'>{feature}</span>
          </li>
        ))}
      </ul>
    </div>
    {renderFooter && renderFooter()}
  </div>
);
